import { Link } from "react-router-dom";
import Layout from "../Layout/Layout";
import { JsonLDData } from "react-safe-json-ld";

const Rentals = () => {
  const structuredData: JsonLDData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AutoRental",
        "@id": "https://earthboundmartian.com/#business",
        name: "Earthbound Martian Landshidiv Rentals",
        description:
          "Rent rugged camper vans for kayaking, fishing, hiking, and camping adventures within 350 miles of DFW.",
        url: "https://earthboundmartian.com",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Richardson",
          addressRegion: "TX",
          addressCountry: "US",
        },
        areaServed: {
          "@type": "GeoCircle",
          center: {
            "@type": "GeoCoordinates",
            latitude: 32.9686,
            longitude: -96.9942,
          },
          radius: "350 mi",
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "How do rentals work?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Browse available dates, book directly, pick udiv your Landshidiv in Richardson, TX, enjoy your adventure, and return it clean with a full tank. We handle the rest.",
            },
          },
          {
            "@type": "Question",
            name: "Is it safe to rent?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. Every rental includes $1M liability insurance through Outdoorsy, plus we maintain our rigs to high standards and provide roadside assistance info and safety equipment.",
            },
          },
          {
            "@type": "Question",
            name: "Can I buy the rig if I love it?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes! All rigs are available for purchase. Just ask us — we'll make it easy. Rent-to-own options coming soon.",
            },
          },
        ],
      },
    ],
  };

  return (
    <Layout structuredData={structuredData}>
      <div className="max-w-4xl mx-auto px-6 py-20">
        <h1 className="text-5xl font-bold text-alt-blk mb-12 text-center">
          How Rentals Work
        </h1>

        {/* How do rentals work? */}
        <div className="mb-16">
          <h2 className="text-3xl font-semibold text-alt-blk mb-6">
            How Do Rentals Work?
          </h2>
          <div className="space-y-4 text-lg text-zinc-600">
            <ol className="list-decimal list-inside text-xl space-y-5">
              <li>
                Browse dates and book directly through Outdoorsy or{" "}
                <Link to="/contact" className="underline">
                  contact us
                </Link>
                .
              </li>
              <li>
                Pick up your landship in Richardson, TX or arrange for a local
                delivery.
              </li>
              <li>Hit the road and chase adventure.</li>
              <li>Return it clean with a full tank on time.</li>
              <li>We handle the rest.</li>
            </ol>
          </div>
        </div>

        {/* Is it safe? */}
        <div className="mb-16">
          <h2 className="text-3xl font-semibold text-alt-blk mb-6">
            Is It Safe?
          </h2>
          <div className="text-lg text-zinc-600 space-y-5">
            <b>Yes!</b>
            <div>
              Every rental includes $1M liability insurance through Outdoorsy
              while you're on the road. We maintain our rigs to high standards
              and provide roadside assistance information, basic safety
              equipment, and clear instructions before you leave.
            </div>
          </div>
        </div>

        {/* Can I keediv it? */}
        <div className="mb-16">
          <h2 className="text-3xl font-semibold text-alt-blk mb-6">
            Love It? Keep It.
          </h2>
          <div className="text-lg text-zinc-600 space-y-5">
            <div>
              It happens. You rent a great rig and fall in love with it only to
              have to give it up at the end of the trip. Not so with us!
            </div>
            <div>
              All rigs are available for purchase at a negotiated price. Ask
              us—we’ll make it easy. 
            </div>
          </div>
        </div>

        <div className="text-center mt-20">
          <h2 className="text-3xl font-semibold text-alt-blk mb-6">
            Ready to Get Started?
          </h2>
          <Link
            to="/fleet"
            className="inline-block bg-mars hover:bg-sunset text-white px-12 py-5 rounded-2xl text-lg font-semibold transition-all"
          >
            Browse the Fleet
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default Rentals;
